module.exports = __webpack_public_path__ + "img/zczy.4b0ae185.png";